import { Component, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { switchMap, map, catchError, of, timer, forkJoin, take } from 'rxjs';
import { CommonService, MetricService } from '../../api/services';
import { BasicComponent } from '../../app/models/basic.component';
import { MetricCatalogService } from '../../services/metric-catalog.service';

@Component({
  selector: 'ze-login-success',
  standalone: false,
  templateUrl: './login-success.component.html',
  styleUrl: './login-success.component.css',
})
export class LoginSuccessComponent extends BasicComponent {
  private readonly oidcSecurityService = inject(OidcSecurityService);
  private readonly common = inject(CommonService);
  private readonly metricService = inject(MetricService);
  private readonly metricCatalog = inject(MetricCatalogService);

  ngOnInit() {
    this.oidcSecurityService
      .checkAuth()
      .pipe(
        switchMap((ok) =>
          forkJoin({
            roles: this.common.commonControllerFindRoles(),
            metrics: this.metricService.metricControllerFindAllMetric({ limit: 0 }),
          }).pipe(
            map(({ roles, metrics }) => {
              this.auth.appRoles = roles.data.roles;
              this.metricCatalog.load(metrics.data.list);
              return ok;
            }),
            catchError((error) => {
              this.goto('/login-unauth');
              return of(error);
            }),
          ),
        ),
      )
      .subscribe({
        next: async (ok) => {
          try {
            await this.auth.postLogin(ok);
            this.goto(this.router.routerState?.snapshot?.url || '/');
          } catch {
            this.goto('/login-unauth');
          }
        },
        error: (e) => {
          console.error(e);
          this.goto('/login-unauth');
        },
      });
  }

  goto(url: string) {
    timer(2000)
      .pipe(take(1))
      .subscribe((t) => this.router.navigateByUrl(url));
  }
}
